import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const PublishReportModal = ({ 
  show, 
  isPublishSuccess, 
  publishSuccessMessage, 
  handleCancel, 
  handlePublishContinue 
}) => (
  <Modal
    show={show}
    onHide={handleCancel}
    backdrop="static"
    keyboard={false}
    dialogClassName='checkerModal'
  >
    <Modal.Header closeButton>
      <Modal.Title>Publish Report?</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {isPublishSuccess ? (
        <p>{publishSuccessMessage}</p>
      ) : (
        <p>{publishSuccessMessage || "Do you wish to continue?"}</p>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
      {!isPublishSuccess && (
        <Button variant="primary" onClick={handlePublishContinue}>Continue</Button>
      )}
      {isPublishSuccess && (
        <Button variant="primary" onClick={() => window.location.reload()}>Close</Button>
      )}
    </Modal.Footer>
  </Modal>
);

export default PublishReportModal;
